'use client';

import Link from 'next/link';

const AboutUsScreen = () => {
  return (
    <div className="mt-24 flex min-h-screen bg-white">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-y-9 px-6 py-12">
        <div className="flex flex-col gap-y-6">
          <p className="text-4xl font-bold">About us</p>
          <p className="text-justify text-xl font-normal">
            Welcome to{' '}
            <Link
              href="https://www.indiemunkey.com/"
              className="text-vivid-orange underline-offset-4 hover:underline"
            >
              IndieMunkey.com
            </Link>
            , your ultimate destination for discovering and supporting the next
            generation of indie manga creators. We are a platform dedicated to
            bridging the gap between talented artists and passionate readers who
            crave unique, original stories that push boundaries and inspire
            imagination. At IndieMunkey, we believe that great stories can come
            from anywhere, and our mission is to give independent creators the
            tools, exposure, and community they need to share their work with
            the world. Whether you&apos;re an artist looking to showcase your
            manga, or a fan hungry for fresh, compelling narratives, IndieMunkey
            is here to connect you with the best in indie manga.
          </p>
        </div>
        <div className="flex flex-col gap-y-6">
          <p className="text-4xl font-bold">Why IndieMunkey?</p>
          <p className="text-justify text-xl font-normal">
            We offer more than just a space for creators to publish their work.
            Our platform empowers artists to maintain creative freedom and
            ownership of their work while providing the resources to help them
            succeed. Join our vibrant community of indie manga lovers, and dive
            into a world where stories are limitless, creativity thrives, and
            indie voices shine.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUsScreen;
